export default function PageHeader({
  icon: Icon,
  title,
  subtitle,
  right,
  compact = false,
}) {
  const padY = compact ? "pt-4 pb-3" : "pt-8 pb-6";
  const iconSize = compact ? "h-9 w-9" : "h-12 w-12";
  const titleSize = compact
    ? "text-xl md:text-2xl"
    : "text-2xl md:text-3xl";
  return (
    <div
      className={`flex items-start justify-between gap-4 px-6 md:px-10 ${padY} border-b border-white/5`}
    >
      <div className="flex items-start gap-4 min-w-0">
        {Icon && (
          <div
            className={`hidden sm:flex ${iconSize} items-center justify-center rounded-xl bg-consensus-500/10 border border-consensus-500/20 text-consensus-300 shadow-glow`}
          >
            <Icon className={compact ? "h-5 w-5" : "h-6 w-6"} />
          </div>
        )}
        <div className="min-w-0">
          <h1 className={`${titleSize} font-bold tracking-tight truncate`}>
            {title}
          </h1>
          {subtitle && (
            <p
              className={
                compact
                  ? "text-white/55 mt-0.5 text-xs md:text-sm"
                  : "text-white/60 mt-1 text-sm md:text-base"
              }
            >
              {subtitle}
            </p>
          )}
        </div>
      </div>
      {right && <div className="shrink-0">{right}</div>}
    </div>
  );
}
